<template>
  <div v-if="!fetching">
    <ProductHeader v-bind="{ title: product.name }">
      <FileUpload @file-upload="updateCover">
        <template #button="{ fileUploadButtonClick }">
          <img
            v-if="cover"
            :srcset="cover.srcsets || ''"
            @load.once="onImageLoad"
            @click="fileUploadButtonClick"
            sizes="1px"
            :src="cover.url"
            class="block rounded w-full cursor-pointer"
          />
          <div
            v-else
            @click="fileUploadButtonClick"
            class="aspect-ratio-4/3 w-full rounded bg-gray-900 cursor-pointer"
          />
        </template>
      </FileUpload>
    </ProductHeader>
    <TheMenu :is-package="product.package" />
    <div class="p-16">
      <Transition name="slide-right" mode="out-in">
        <RouterView />
      </Transition>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import FileUpload from '@/components/Ui/FileUpload.vue';
import mediableMixin from '@/mixins/mediableMixin';
import ProductHeader from '@/components/Products/ProductHeader.vue';
import TheMenu from './_basicProductId/components/TheMenu.vue';

export default {
  mixins: [mediableMixin],
  components: {
    ProductHeader,
    TheMenu,
    FileUpload,
  },
  props: {
    basicProductId: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    fetching: false,
  }),
  computed: {
    ...mapGetters('admin/products', ['product']),
    cover() {
      const { media = [] } = this.product || {};
      return media.find((item) => item.collection === 'images') || null;
    },
  },
  created() {
    const { basicProductId } = this;
    this.doGetProduct(basicProductId);
  },
  beforeRouteUpdate(to, from, next) {
    const { basicProductId: basicProductIdTo } = to.params;
    const { basicProductId: basicProductIdFrom } = from.params;
    if (basicProductIdTo !== basicProductIdFrom || this.product === null) {
      this.setCurrent(null);
      this.doGetProduct(basicProductIdTo);
    }
    next();
  },
  destroyed() {
    this.setCurrent(null);
  },
  methods: {
    ...mapActions('admin/products', ['getBasicProduct', 'updateProductCover']),
    ...mapMutations('ui/products', ['setCurrent']),
    doGetProduct(basicProductId) {
      this.fetching = true;
      this.getBasicProduct({ basicProductId, params: { include: 'media,categories,tags' } })
        .then(() => {
          this.fetching = false;
        })
        .catch(() => {
          this.fetching = true;
        });
    },
    updateCover({ config, data, success, error }) {
      const { basicProductId } = this;
      this.updateProductCover({ config, productId: basicProductId, formData: data })
        .then(() => {
          success();
        })
        .catch(() => {
          error();
        });
    },
  },
};
</script>
